import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import isArray from 'lodash/isArray';
import { toArray } from '../_utils/react-children';
var DEFAULT_ITEM_WIDTH = 160;
var DEFAULT_MAX_WIDTH = 800;
var DEFAULT_MARGIN_WIDTH = 40;
var DEFAULT_ITEM_NUM = 5;
export var isString = function isString(value) {
  return typeof value === 'string';
};
export var isNumber = function isNumber(value) {
  return typeof value === 'number';
};
export var getColumnWidthList = function getColumnWidthList(nodeList) {
  var _context;
  if (!nodeList) return [];
  var columnWidthList = [];
  _mapInstanceProperty(_context = toArray(nodeList)).call(_context, function (item) {
    if (!item || isString(item) || isNumber(item)) return item;
    var width = getItemWidth(item.props.children);
    columnWidthList.push(width);
    return item;
  });
  return columnWidthList;
};
// 计算外层面板的总宽度 DEFAULT_MAX_WIDTH: 824px, 最多四列（790px），
// 每列160px+40px
// 其中160px是width,40px是marginRight
export var getWrapWidth = function getWrapWidth(nodelist) {
  var wrapWidth = 0;
  var totalWidth = 0;
  var columnWidthList = getColumnWidthList(nodelist);
  _mapInstanceProperty(columnWidthList).call(columnWidthList, function (width) {
    totalWidth += width + DEFAULT_MARGIN_WIDTH;
    if (totalWidth < DEFAULT_MAX_WIDTH) {
      wrapWidth = totalWidth;
    } else {
      wrapWidth = DEFAULT_MAX_WIDTH;
    }
    return width;
  });
  return wrapWidth + 10;
};
// 计算子项的宽度
export var getItemWidth = function getItemWidth(children) {
  if (!isArray(children)) {
    return DEFAULT_ITEM_WIDTH;
  }
  if (!children || children.length <= DEFAULT_ITEM_NUM) {
    return DEFAULT_ITEM_WIDTH;
  } else {
    var width = (DEFAULT_ITEM_WIDTH + DEFAULT_MARGIN_WIDTH) * Math.ceil(children.length / DEFAULT_ITEM_NUM) - DEFAULT_MARGIN_WIDTH;
    return width > DEFAULT_MAX_WIDTH ? DEFAULT_MAX_WIDTH : width;
  }
};
export var renderReactNodeFunction = function renderReactNodeFunction(reactNode) {
  if (typeof reactNode === 'function') {
    return reactNode();
  }
  return reactNode;
};
export var isElementInViewport = function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
export var DEFAUTL_PADDING = 15;